import { cn } from '../../lib/cn';
import { Card, Badge } from '../ui';
import type { JourneyDefinition } from '../../hx/framework';

type Props = {
  journey: JourneyDefinition;
  className?: string;
};

export function JourneyCard({ journey, className }: Props) {
  return (
    <Card className={cn(className)} padding="sm">
      <div className="flex flex-wrap items-start justify-between gap-2">
        <p className="font-medium text-slate-900 dark:text-slate-100">{journey.label}</p>
        {journey.workflow_type && (
          <Badge variant="info">{journey.workflow_type.replace(/_/g, ' ')}</Badge>
        )}
      </div>
      {journey.description && (
        <p className="mt-1 text-xs text-slate-500">{journey.description}</p>
      )}
      {journey.estimated_minutes != null && (
        <p className="mt-2 text-xs text-slate-400">~{journey.estimated_minutes} min</p>
      )}
      {journey.steps && journey.steps.length > 0 && (
        <ol className="mt-3 space-y-1 text-xs text-slate-600 dark:text-slate-400">
          {journey.steps.map((step, i) => (
            <li key={step}>{i + 1}. {step}</li>
          ))}
        </ol>
      )}
      {journey.modules && (
        <p className="mt-2 text-[10px] text-slate-400">{journey.modules.join(' · ')}</p>
      )}
    </Card>
  );
}
